import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon, Typography } from '@mui/material';
import { ReactComponent as PlusIcon } from 'mui/assets/icons/plus-icon.svg';
import { formatDate, formatTime, getFormattedDateTime } from 'utils/momentHelpers';
import { StyledSummaryList, StyledWrapperDate, StyledDate, StyledCancellationNote, StyledSvgIcon } from './styles';

import translationsCancellation from './data/translationsCancellation';

const SummaryList = ({ stepTimeData, stepLocationData, serviceName, noBookingAvailable, timeOut, completed }) => {
  const [sdate, stime] = getFormattedDateTime(stepTimeData?.time);
  const countryTranslation = translationsCancellation[process.env.GATSBY_COUNTRY_CODE];
  const { cancelled } = countryTranslation;

  return (
    <StyledSummaryList>
      {serviceName && (
        <Typography component="p" variant="DS_copyBigRegular" data-test="booking-summary-service">
          {serviceName}
        </Typography>
      )}
      <ul>
        <StyledWrapperDate>
          {stepTimeData?.time && (
            <StyledDate
              className="time-summary"
              component="li"
              variant="DS_copyBigRegular"
              data-test="booking-summary-date"
              $noBookingAvailable={noBookingAvailable}
              $timeOut={timeOut}
            >
              {completed && (
                <StyledSvgIcon>
                  <SvgIcon component={PlusIcon} inheritViewBox={true}></SvgIcon>
                </StyledSvgIcon>
              )}{' '}
              {formatDate(sdate)}, {formatTime(stime)}
            </StyledDate>
          )}
          {noBookingAvailable ? (
            <StyledCancellationNote className="time-summary" component="li" variant="DS_copyMediumRegular">
              {cancelled}
            </StyledCancellationNote>
          ) : null}
        </StyledWrapperDate>
        {stepLocationData?.heading && (
          <Typography component="li" variant="DS_copyBigRegular" data-test="booking-summary-location">
            {stepLocationData.heading}
          </Typography>
        )}
        {stepLocationData?.address && (
          <Typography
            className="address-summary"
            component="li"
            variant="DS_copyMediumRegular"
            data-test="booking-summary-address"
          >
            {stepLocationData?.address || ''}
          </Typography>
        )}
        {stepLocationData?.phoneNumber && (
          <Typography
            className="phone-number-summary"
            component="li"
            variant="DS_copyMediumRegular"
            data-test="booking-summary-phone-number"
          >
            {stepLocationData?.phoneNumber || ''}
          </Typography>
        )}
      </ul>
    </StyledSummaryList>
  );
};

SummaryList.propTypes = {
  config: PropTypes.shape({
    service: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
  }),
  stepLocationData: PropTypes.shape({
    address: PropTypes.string,
    heading: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string,
  }),
  stepTimeData: PropTypes.shape({
    time: PropTypes.string,
  }),
};

export default SummaryList;
